<template>
  <div class="main-container">
    <div class="success">
      <div>
        <img
          src="../../images/pay-success@2x.png"
          style="width: 180px; height: 108px"
        />
      </div>
      <div class="title">支付成功</div>
      <div class="tip">
        <span>前往</span>
        <router-link
          :to="{ name: router, query: { type: $route.query.type } }"
          style="margin: 0 5px"
        >
          {{ label }}
        </router-link>
        <span v-if="is_course || type == 19">学习吧</span>
        <span v-else-if="type == 17">查看已购买课时</span>
        <span v-else-if="type == 20">查看我的会员</span>
        <span v-else-if="type == 21">做题吧</span>
        <span v-else-if="type == 22">阅读吧</span>
      </div>
      <template>
        <div class="er-img" v-if="codeInfo.qrcode_url">
          <img :src="codeInfo.qrcode_url" style="width: 80px; height: 80px" />
        </div>
        <div class="code-title">{{ codeInfo.qrcode_title }}</div>
      </template>
    </div>
    <el-dialog
      class="dialog"
      :visible.sync="showModal"
      :close-on-click-modal="false"
      width="278px"
    >
      <div class="speaker"></div>
      <div class="poster">
        <img class="poster-img" :src="mp_poster" />
      </div>
      <a class="close" @click="modalClose"></a>
    </el-dialog>
  </div>
</template>
<script>
// import VueQr from "vue-qr";

export default {
  name: "OrderSuccess",
  components: {
    // VueQr,
  },
  data() {
    return {
      router: "",
      label: "",
      codeInfo: {},
      showModal: false,
      mp_poster: "",
      is_course: false,
      shop_id: this.$route.query.shop_id,
      type: this.$route.query.type,
    };
  },
  async created() {
    let type = this.type;
    let spell_id = this.$route.query.spell_id;
    // if (type == 1) {
    //   this.router = "MemberOto";
    //   this.label = "我的预约";
    // } else
    if (type == 17) {
      this.router = "MemberPeriods";
      this.label = "我的课时包";
    } else if (type == 4) {
      this.router = "MemberOto";
      this.label = "我的约课";
    } else if (type == 19) {
      this.router = "MemberClasses";
      this.label = "我的班级";
    } else if (type == 20) {
      this.router = "Vip";
      this.label = "会员专区";
    } else if (type == 21) {
      this.router = "ExamPackage";
      this.label = "套卷练习";
    } else if (type == 22) {
      this.router = "MemberEbooks";
      this.label = "我的电子书";
    } else if (type != 14 && type != 12 && !spell_id) {
      this.router = "MemberStudy";
      this.label = "我的课程";
      this.is_course = true;
    } else {
      this.router = "MemberOrder";
      this.label = "我的订单";
    }

    let data = await this.$http.put("/api/app/systemSet/available/oauthConfig");
    if (data.mpLogin.mp_switch == 1) {
      this.mp_poster = data.mpLogin.mp_poster;
      this.showModal = true;
    } else {
      this.$store.commit("setCouponDlg", {
        show: true,
        type: 3,
        orderId: this.$route.params.id,
      });
    }
  },
  async mounted() {
    //班级订单可能会设置有二维码，需要获取后台是否配置二维码
    if (this.type == 19) {
      const qrCode = await this.$http.get(
        `/api/app/stateSchool/class/qrcode/${this.shop_id}`,
      );
      this.codeInfo = qrCode || {};
    }
  },
  methods: {
    modalClose() {
      this.showModal = false;
      this.$store.commit("setCouponDlg", {
        show: true,
        type: 3,
        orderId: this.$route.params.id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";

.success {
  background-color: white;
  text-align: center;
  margin-top: 30px;
  padding-top: 64px;
  padding-bottom: 46px;
  .title {
    font-size: 24px;
    font-family: PingFang SC Semibold, PingFang SC Semibold-Semibold;
    font-weight: 600;
    margin: 32px 0 8px 0;
  }
  .tip {
    font-size: 14px;
    color: rgba(140, 140, 140, 1);

    a {
      color: $primary-color;
    }
  }
  .er-img {
    margin: 48px 0 16px 0;
  }
  .code-title {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #333333;
  }
}

.timer {
  padding: 88px 0;
  text-align: center;
  /deep/ a {
    color: $primary-color;
  }
}

.dialog {
  /deep/ {
    .el-dialog {
      height: 350px;
      margin-top: 0 !important;
      top: 50%;
      margin-top: -240px !important;
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      position: relative;
      padding-top: 84px;
      overflow: visible;
    }
  }
  .speaker {
    background-image: url("~@/assets/images/order/speaker@2x.png");
    background-size: 100% 100%;
    height: 157px;
    position: absolute;
    width: 100%;
    top: -65px;
  }
  .poster {
    width: 230px;
    height: 230px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .poster-img {
    max-width: 100%;
    max-height: 100%;
  }
  .close {
    position: absolute;
    width: 18px;
    height: 18px;
    background-image: url("~@/assets/images/order/close@2x.png");
    background-size: 100% 100%;
    cursor: pointer;
    right: -44px;
    top: 3px;
  }
}
</style>
